import { currencyTest } from '../../../js/statsig/ActiveFlags';

export const UseCurrencyParserAbTest = (
  price: string,
  experimentFlag: string,
  experimentVariation: string,
) => {
  switch (true) {
    case experimentFlag === currencyTest.flagKey &&
      experimentVariation === currencyTest.variationB:
      return price.replace('€', '').replace('CHF', '').trim();
    default:
      return price;
  }
};
